import {createStateMaker} from '@shared/helpers/object'

import {BranchState} from '../interfaces'

export const getInitialState = (): BranchState => ({
    branchNamesByDeliveryGroupKey: {},
    deposit: {
        type: null,
        amount: 0,
    },
})

export const makeMock = createStateMaker<BranchState>(getInitialState)
